import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { SingleDatePicker } from 'react-dates';

const AssignSupplierAndHandoverDate = ({
	show,
	onClose,
	suppliers,
	onSelectSupplier,
	onChange,
	onSubmit,
	supplierAndETDValue,
	onNavigateToSupplierPage,
	errors,
	showSuppliers,
	setShowSupplierList,
	onChangeDate,
	startDate,
	endDate,
	updateType
}) => {
	const handleOutsideClick = () => {
		setShowSupplierList(false);
	};
	const [focusedHandoverDate, setFocusedHandoverDate] = useState(null);
	const [focusedDeliveryDate, setFocusedDeliveryDate] = useState(null);
	const [factoryHandoverDate, setFactoryHandoverDate] = useState(null);
	const [factoryDeliveryDate, setFactoryDeliveryDate] = useState(null);

	return (
		<Modal show={show} backdrop="static" className="supplier-selection-popup" centered>
			<div onClick={handleOutsideClick}>
				<Modal.Header>
					<h3 className="semibold-16 mb-0 ml-3">Assign supplier with handover & factory date</h3>
				</Modal.Header>
				<Modal.Body>
					<div className="common-popup-body">
						<div className="container px-0">
							<div className="row">
								{updateType === 'SUPPLIER' && (
									<div className="col-md-12">
										<div className="form-group">
											{/* supplier  */}
											<div className="supplier-list-and-search ">
												<label htmlFor="b-title">Assign Supplier</label>
												<div className="with-icon right-icon">
													<input
														name="searchSupplier"
														type="text"
														autoComplete="off"
														placeholder="Supplier name"
														value={supplierAndETDValue?.searchSupplier}
														onChange={onChange}
														onClick={(e) => {
															e.stopPropagation();
															setShowSupplierList(true);
														}}
													/>
													<span className="right-icon">
														<img
															src={`${process.env.PUBLIC_URL}/icons/search.png`}
															alt="search"
														/>
													</span>
												</div>
												{errors?.includes('SUPPLIER_ERROR') && (
													<p className="error">Supplier name is required</p>
												)}
												{showSuppliers && (
													<div className="suggested-supplier-dropdown scroll-y-label shadow-2dp">
														<div className="supplier-list">
															{suppliers &&
																suppliers.length > 0 &&
																suppliers.map((item) => (
																	<div
																		className="single-supplier"
																		key={item.id}
																		onClick={() =>
																			onSelectSupplier(item?.id)
																		}
																	>
																		<p>{item.name}</p>
																	</div>
																))}
														</div>

														{!suppliers?.length && (
															<div className="supplier-add mt-12">
																<button
																	className="button text-only pl-0"
																	onClick={() => onNavigateToSupplierPage()}
																>
																	Add new supplier
																</button>
															</div>
														)}
													</div>
												)}
											</div>
										</div>
									</div>
								)}
								{updateType === 'FACTORY_ETD' && (
									<>
										<div className="col-md-12">
											<div className="form-group">
												<label htmlFor="b-title">
													Handover to factory (mm/dd/yyyy)
												</label>

												<SingleDatePicker
													date={factoryHandoverDate} // Moment.js object or null
													onDateChange={(selectedDate) => {
														setFactoryHandoverDate(selectedDate);
														onChangeDate(
															'factoryHandoverDate',
															selectedDate?.format('YYYY-MM-DD')
														);
													}} // Prop to handle date change
													focused={focusedHandoverDate} // Boolean indicating if the input is focused
													onFocusChange={({ focused }) =>
														setFocusedHandoverDate(focused)
													} // Prop to handle focus change
													id="factoryHandoverDate" // A unique ID for the input
													numberOfMonths={1}
													displayFormat="MM/DD/YYYY"
													placeholder="mm/dd/yyyy"
													block
													isOutsideRange={(day) =>
														!day.isBetween(startDate, endDate, 'day', '[]')
													} // Disable dates outside range
												/>
												{errors?.includes('HANDOVER_ERROR') && (
													<p className="error">Handover date is required</p>
												)}
											</div>
										</div>

										<div className="col-md-12">
											<div className="form-group ">
												<label htmlFor="acname">Factory ETD (mm/dd/yyyy)</label>

												<SingleDatePicker
													date={factoryDeliveryDate} // Moment.js object or null
													onDateChange={(selectedDate) => {
														setFactoryDeliveryDate(selectedDate);
														onChangeDate(
															'factoryDeliveryDate',
															selectedDate?.format('YYYY-MM-DD')
														);
													}} // Prop to handle date change
													focused={focusedDeliveryDate} // Boolean indicating if the input is focused
													onFocusChange={({ focused }) =>
														setFocusedDeliveryDate(focused)
													} // Prop to handle focus change
													id="factoryDeliveryDate" // A unique ID for the input
													numberOfMonths={1}
													displayFormat="MM/DD/YYYY"
													placeholder="mm/dd/yyyy"
													block
													isOutsideRange={(day) =>
														!day.isBetween(startDate, endDate, 'day', '[]')
													} // Disable dates outside range
												/>
												{errors?.includes('DELIVERY_ERROR') && (
													<p className="error">Delivery date is required</p>
												)}
											</div>
										</div>

										{/*<div className="col-md-12">*/}
										{/*	<div className="form-group ">*/}
										{/*		<label htmlFor="quantityIncrease">*/}
										{/*			Quantity increase (%)*/}
										{/*		</label>*/}
										{/*		<input*/}
										{/*			name="quantityIncrease"*/}
										{/*			type="number"*/}
										{/*			value={supplierAndETDValue?.quantityIncrease}*/}
										{/*			onChange={onChange}*/}
										{/*		/>*/}
										{/*	</div>*/}
										{/*</div>*/}
									</>
								)}
							</div>
						</div>
					</div>
				</Modal.Body>
			</div>
			<Modal.Footer onClick={handleOutsideClick}>
				<div className="footer-buttons text-right mr-3">
					<button className="button outline size32" onClick={onClose}>
						Cancel
					</button>
					<button className="button size32 ml-2" disabled={false} onClick={onSubmit}>
						Submit
					</button>
				</div>
			</Modal.Footer>
		</Modal>
	);
};

export default AssignSupplierAndHandoverDate;
